module.exports = __webpack_public_path__ + "static/media/content_system_area_ios.fcfa3e4d.png";